/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { createSlice } from '@reduxjs/toolkit'
import { RootState } from './store';
import { MessageType } from '../components/modals/SuccessErrorModal';

// Define a type for the slice state
interface userRoleDataState {
  roleResourceData?:any;
  stage: string;
  isAlertOpen: boolean;
  message: string;
  messageType:MessageType;
  isReqroleresourceVisited:boolean;

}

// Define the initial state using that type
const initialState: userRoleDataState = {
  stage: 'OrgEngine',
  roleResourceData: {},
  isAlertOpen: false,
  message: '',
  messageType:MessageType.info,
  isReqroleresourceVisited:false

  // userRoles:undefined
}

export const userRolesSlice = createSlice({
  name: 'userRole',
  initialState,
  reducers: {
    setRoleResourceData:(state,action)=>{
      state.roleResourceData = action.payload
    },
    setStage:(state,action)=>{
      state.stage = action.payload
    },
    setIsAlertOpen:(state,action)=>{
      state.isAlertOpen = action.payload
    },
    setMessage:(state,action)=>{
      state.message = action.payload
    },
    setMessageType:(state,action)=>{
      state.messageType = action.payload
    },
    setisReqroleresourceVisited:(state,action)=>{
      state.isReqroleresourceVisited = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { setRoleResourceData,setStage, setIsAlertOpen, setMessage, setMessageType, setisReqroleresourceVisited} = userRolesSlice.actions;
export const userRoleSelector = (state: RootState) => state.userRole;

export default userRolesSlice.reducer;